import { useState } from 'react';
import IconSvg, { Icons } from 'src/assets/icons/IconSvg';
import LeaderboardSearchInput from 'src/components/leaderboard/LeaderboardSearchInput';
import LeaderboardFilterMenu from 'src/components/leaderboard/LeaderboardFilterMenu';
import LeaderboardCreatorsTab from './tabs/LeaderboardCreatorsTab';
import LeaderboardParticipantsTab from './tabs/LeaderboardParticipantsTab';
import LeaderboardCollectionTab from './tabs/LeaderboardCollectionTab';
import { useViewport } from 'src/context/ViewportContext';
import type { LeaderboardPeriod } from 'src/types/leaderboard';

const LeaderBoard = () => {
  const [activeTab, setActiveTab] = useState('creators');
  const [search, setSearch] = useState('');
  const [period, setPeriod] = useState<LeaderboardPeriod>('all');
  const { isMobile } = useViewport();

  const tabs: { key: string; label: string; icon: Icons }[] = [
    { key: 'creators', label: 'Creators', icon: 'createS' },
    { key: 'participants', label: 'Participants', icon: 'userS' },
    { key: 'collection', label: 'Collection / Runes', icon: 'allS' },
  ];

  const sortedTabs = isMobile ? [...tabs].sort(a => (a.key === activeTab ? -1 : 1)) : tabs;

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    setSearch('');
  };

  const searchPlaceholder =
    activeTab === 'collection' ? 'Search Collection' : 'Search User';

  return (
    <>
      <h3 className="mb-6 text-brand-magnolia xl:mb-8">Leaderboard</h3>

      <div className="flex flex-col-reverse gap-3 mb-2 xl:justify-between xl:items-center xl:flex-row">
        <div className="flex overflow-x-auto gap-3 items-center no-scrollbar">
          {sortedTabs.map(tab => (
            <button
              key={tab.key}
              className={`flex gap-2 items-center py-2 px-3 rounded-lg font-medium flex-shrink-0 ${
                activeTab === tab.key ? 'bg-grayscale-800 text-grayscale-100' : 'text-grayscale-300'
              }`}
              onClick={() => handleTabClick(tab.key)}
            >
              <IconSvg icon={tab.icon} />

              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="flex gap-3 items-center">
          <LeaderboardSearchInput
            placeholder={searchPlaceholder}
            value={search}
            onChange={setSearch}
          />

          <LeaderboardFilterMenu
            period={period}
            onApply={setPeriod}
          />
        </div>
      </div>

      {activeTab === 'creators' && <LeaderboardCreatorsTab search={search} period={period} />}
      {activeTab === 'participants' && <LeaderboardParticipantsTab search={search} period={period} />}
      {activeTab === 'collection' && <LeaderboardCollectionTab search={search} period={period} />}
    </>
  );
};

export default LeaderBoard;
